import { Done } from "@mui/icons-material";
import { useTheme } from "@mui/material";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

export function Perks({ items }: { items: React.ReactNode[] }) {
  const theme = useTheme();

  return (
    <>
      {items.map((item) => (
        <Box key={item?.toString()} display="flex" alignItems="flex-start">
          <Box mr={1}>
            <Done
              style={{
                color: theme.palette.text.secondary,
              }}
            />
          </Box>
          <Typography color="textSecondary">{item}</Typography>
        </Box>
      ))}
    </>
  );
}
